import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { BookOpen, LogOut } from "lucide-react";
import { Button } from "../ui/button";
import { getUser, logout } from "../../lib/api";
import { SF } from "../../constants/testIds";

export default function Navbar() {
    const navigate = useNavigate();
    const loc = useLocation();
    const user = getUser();

    const onLogout = async () => {
        await logout();
        navigate("/");
    };

    return (
        <header className="sticky top-0 z-50 backdrop-blur-xl bg-background/80 border-b border-border">
            <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
                <Link to="/" data-testid={SF.navHome} className="flex items-center gap-2 group">
                    <BookOpen className="w-5 h-5 text-primary" strokeWidth={1.5} />
                    <span className="font-serif text-xl tracking-tight text-primary">Athena&apos;s Atlas</span>
                </Link>
                <nav className="flex items-center gap-1 sm:gap-3">
                    {user ? (
                        <>
                            <Link to="/dashboard" data-testid={SF.navDashboard}>
                                <Button variant="ghost" className="text-foreground">My Books</Button>
                            </Link>
                            <Link to="/create" data-testid={SF.navCreate}>
                                <Button className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-xl">
                                    Create a book
                                </Button>
                            </Link>
                            <Button
                                onClick={onLogout}
                                data-testid={SF.navLogout}
                                variant="ghost"
                                size="icon"
                                aria-label="Log out"
                            >
                                <LogOut className="w-4 h-4" strokeWidth={1.5} />
                            </Button>
                        </>
                    ) : (
                        <>
                            <Link to="/login" data-testid={SF.navLogin}>
                                <Button variant="ghost">Log in</Button>
                            </Link>
                            <Link to="/signup" data-testid={SF.navSignup}>
                                <Button className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-xl">
                                    Start a story
                                </Button>
                            </Link>
                        </>
                    )}
                </nav>
            </div>
        </header>
    );
}
